import React, { Component } from 'react'
import { Sidebar, Divider, Button, Menu } from 'semantic-ui-react';

class ColorPanel extends Component {
    render() {
        return (
            
            <Sidebar
            as={Menu}
            icon = "labeled"
            inverted
            vertical
            visible
            width = "very thin"
            >
                <Divider />
                <Button icon = "add" size="small" color = "blue" />
            </Sidebar>
        )
    }
}

export default ColorPanel;



// WEBPACK FOOTER //
// ./src/components/ColorPanel/ColorPanel.js